import React from 'react';
import classNames from 'classnames';

import SectionArticle from '../../PageBuilder/SectionBuilder/SectionArticle';
import SectionContainer from '../../PageBuilder/SectionBuilder/SectionContainer';
import Field, { hasDataInFields } from '../../PageBuilder/Field';
import BlockBuilder from '../../PageBuilder/BlockBuilder';

import ContactUsForm from './ContactUsForm';
import css from './SectionContactUs.module.css';

// The Console section (on the contact_us page) that gets the contact form next to its content.
export const CONTACT_US_SECTION_ID = 'contact-us';

/**
 * The "contact-us" article section: its Console content (the image block) on the left, and the
 * contact form on the right. Stacked on mobile.
 *
 * @component
 * @param {Object} props - The props of an article section from the PageBuilder
 * @returns {JSX.Element}
 */
const ContactUsSection = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}
      <div className={classNames(defaultClasses.blockContainer, css.layout)}>
        <div className={css.content}>
          <BlockBuilder
            blocks={blocks}
            sectionId={sectionId}
            ctaButtonClass={defaultClasses.ctaButton}
            options={options}
          />
        </div>
        <ContactUsForm className={css.form} />
      </div>
    </SectionContainer>
  );
};

/**
 * Article sections for CMS pages: the contact-us section gets the contact form, every other
 * article section renders as usual.
 *
 * @component
 * @param {Object} props - The props of an article section from the PageBuilder
 * @returns {JSX.Element}
 */
const SectionArticleWithContactUs = props =>
  props.sectionId === CONTACT_US_SECTION_ID ? (
    <ContactUsSection {...props} />
  ) : (
    <SectionArticle {...props} />
  );

export default SectionArticleWithContactUs;
